<template>
  <div class="walls">
    <div class="walls__left"></div>
    <div class="walls__right"></div>
    <div class="walls__top">
      <img class="walls__sign" src="../assets/img/walls-sign.png" alt="Yellow Brick Road - Happy Birthday Elton!">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Walls',
  }
</script>